import { isNullOrUndefined } from './';

export default function isNullOrUndefinedOrEmpty(value) {
  return isNullOrUndefined(value) || value === '';
}
